<template>
  <main class="user-detail-popup">
   <div class="user-wrapper-outer w100w">
     <div class="wrapper-title">
       <div class="subWrap fx vt-c gap-10">
         <span>게임별 베팅설정</span>
         <button type="button" class="btn-settings" @click="setGameBetAll(true)">ON</button>
         <button type="button" class="btn-settings" @click="setGameBetAll(false)">OFF</button>
         <button type="button" class="btn-reset" @click="gameListReload()"><i class="fas fa-redo-alt"></i></button>
       </div>
       <button class="btn-save user-btn-bg" @click="gameBetUpdate">저장</button>
     </div>
     <div class="wrapper-contents s-content-wrap">
       <template v-for="(item, idx) in gameList" :key="item.code">
         <div class="s-content" >
           <div class="title">
             <span :title="item.codeName">{{ item.codeName }}</span>
           </div>
           <div class="content">
             <div class="toggle-wrap">
               <span class="toggle_text" :class="item.compBetYn === 'Y' ? 'on' : 'off'"></span>
               <input type="checkbox" class="set-switch" @click="switchGame(item)" v-model="item.isBet" />
             </div>
           </div>
         </div>
         <div class="s-content-line" v-if="(idx + 1) % 4 !== 0"></div>
       </template>
     </div>
   </div>
  </main>
</template>

<script>
import lodash from "lodash";
import { getCode } from "@/api/utils";
import {
  companyDetail,
  companyTree,
  companyOption,
  companyOptionSave,
  createOtp,
  getQRCode,
  saveGameBet, saveGameRate, saveMenu, saveSuperGame, getVendorRating, setVendorRating
} from "@/api/company";
import { memberRateUpdata } from "@/api/user";
import { partnerModify } from "@/api/partner";
import { GAME_INFO_LIST } from "@/libs/constants.js";
import subTitle from "@/components/main/PageSubTitle";
import {apiUpdateOtpUseYn} from "@/api/otp";
import {mapState} from "vuex";

export default {
  name: "gameBet",
  components: {
    subTitle
  },
  data() {
    return {
      compStats: {},
      topCompList: [],
      botCompList: [],
      otpQr: false,
      gameBet: false,
      otpUrl: '',
      btnGroup: "pt",
      reqData: {
        memId: this.$route.query.id
      },
      subCompanyList: [],
      memPassChk: "",
      cashInModal: {
        active: false,
        text: "입금",
        reqData: {
          siteId: "",
          inBonusYn: "N",
          inAmt: 0,
          memo: "",
          type: "N"
        }
      },
      detailInfo: {},
      siteOption: {},
      venderRate: {
        active: false,
      },
      cashOutModal: {
        active: false,
        text: "출금",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      creditInModal: {
        active: false,
        text: "크레딧 지급",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      creditOutModal: {
        active: false,
        text: "크레딧 회수",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      rateList: [],
      userRate: [],
      gameList: [],
      menuList: [],
      vendorCompList: [],
      originRate: [],
      rateGroup: {
        etc1: "",
        etc2: ""
      },
      userData: {},
      compInfo: {},
      totalData: null,
      rateAll: '',
      currentTab: 'casino', // casino, slot
      targetSiteId: this.$route.query.id,
      list: {},
      topMemId: ''
    };
  },
  watch: {
    cashInYn (value) {
      this.siteOption.cashInYn = value ? 'Y': 'N'
    },
    cashOutYn (value) {
      this.siteOption.cashOutYn = value ? 'Y': 'N'
    },
    betYn (value) {
      this.siteOption.betYn = value ? 'Y': 'N'
    },
    signupYn (value) {
      this.siteOption.signupYn = value ? 'Y': 'N'
    },
    siteStatusYn (value) {
      this.siteOption.siteStatusYn = value ? 'Y': 'N'
    }
  },
  methods: {
    aaa(url) {
      window.open(url, 'gameBet', 'top=0,left=150,scrollbars=no,resizable=no,width=1455,height=825,status=no');
    },
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
    superGameUpdate () {
      const gameSettingInfoList = []
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        gameSettingInfoList.push({
          groupCode: item.groupCode,
          code: item.code,
          apiVendor: item.apiVendor,
          superUseYn: item.superUseYn
        })
      }
      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        gameSettingInfoList: gameSettingInfoList
      }
      saveSuperGame(params).then(res => {
        if(res.resultCode === '0') {
          alert('사용 게임  설정 저장 완료')
          this.getCompanyDetail()
        }
      })
    },
    menuUpdate () {
      const menuSettingList = []
      for (let i = 0; i < this.menuList.length; i++) {
        const item = this.menuList[i]
        menuSettingList.push({
          menuGroupCode: item.menuGroupCode,
          menuCode: item.menuCode,
          useYn: item.useYn
        })
      }

      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        menuSettingList: menuSettingList
      }
      saveMenu(params).then(res => {
        if(res.resultCode === '0') {
          this.rateAll = ''
          alert('기능 사용여부 설정 저장 완료')
          this.getCompanyDetail()
        }
      })
    },
    gameRateUpdate () {
      const gameSettingInfoList = []
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        gameSettingInfoList.push({
          code: item.code,
          pointRate: item.pointRate
        })
      }

      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        gameSettingInfoList: gameSettingInfoList
      }
      saveGameRate(params).then(res => {
        if(res.resultCode === '0') {
          this.rateAll = ''
          alert('게임 요율 설정 저장 완료')
          this.getCompanyDetail()
        }
      })

    },
    setRateAll () {
      if (this.rateAll.toString() !== '') {
        for (let i = 0; i < this.gameList.length; i++) {
          const item = this.gameList[i]
          item.pointRate = this.rateAll.toString()
        }
      }
    },
    gameRateReload () {
      this.gameList = JSON.parse(JSON.stringify(this.totalData.gameList))
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.isBet = item.compBetYn === 'Y' ? true : false
      }
    },
    gameBetUpdate () {
      const gameSettingInfoList = []
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        gameSettingInfoList.push({
          groupCode: item.groupCode,
          code: item.code,
          compBetYn: item.compBetYn
        })
      }

      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        gameSettingInfoList: gameSettingInfoList
      }
      saveGameBet(params).then(res => {
        if(res.resultCode === '0') {
          alert('게임 베팅 설정 저장 완료')
          this.getCompanyDetail()
        }
      })

    },
    setGameBetAll (value) {
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.compBetYn = value ? 'Y' : 'N'
        item.isBet = value
      }
    },
    gameListReload () {
      this.gameList = JSON.parse(JSON.stringify(this.totalData.gameList))
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.isBet = item.compBetYn === 'Y' ? true : false
      }
    },
    makeOtp () {
      const param = {
        siteId: this.compInfo.siteId
      }
      createOtp(param).then(res => {
        if(res.resultCode === '0') {
          setTimeout(()=>{
            this.otpQr = true
            this.otpUrl = res.data.otpUrl
          },1000)
        }
      })
    },
    getQRData () {
      const param = {
        siteId: this.compInfo.siteId
      }
      getQRCode(param).then(res => {
        if(res.resultCode === '0') {
          setTimeout(()=>{
            this.otpQr = true
            this.otpUrl = res.data.otpUrl
          },1000)

        }
      })
    },
    async _memLogout(siteId) {
      const reqData = {
        siteId: siteId
      };
      const res = await memLogout(reqData);
      if (res.resultCode === "0") {
        alert("로그아웃 처리 완료");
      } else {
        alert("로그아웃 처리 실패");
      }
    },
    async cashApply(type, siteId) {
      let res = "";
      if (type === "in") {
        this.cashInModal.reqData.siteId = siteId;
        res = await cashIn(this.cashInModal.reqData);
        if (res.resultCode === "0") {
          alert("입금완료");
          this.getCompanyDetail();
          this.cashInModal.reqData.inAmt = 0;
        } else {
          alert("입금실패, 다시 시도해주세요.");
        }
      } else if (type === "out") {
        if (this.compInfo.cashAmt < this.cashOutModal.reqData.outAmt) {
          this.cashOutModal.reqData.outAmt = 0;
          alert("출금액은 보유금액보다 적어야 합니다.");
          return;
        }
        this.cashOutModal.reqData.siteId = siteId;
        res = await cashOut(this.cashOutModal.reqData);
        if (res.resultCode === "0") {
          alert("출금완료");
          this.getCompanyDetail();
          this.cashOutModal.reqData.outAmt = 0;
        } else {
          alert("출금실패, 다시 시도해주세요.");
        }
      }
    },
    async userInfoUpdate() {
      const reqData = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        password: this.compInfo.memPass,
        siteName: this.compInfo.siteName,
        userCountLimit: this.compInfo.userCountLimit,
        compCountLimit: this.compInfo.compCountLimit
      };
      const res = await partnerModify(reqData);
      if (res.resultCode === "0") {
        alert("회원정보수정 완료");
      } else {
        alert("회원정보 변경실패, 다시 시도해주세요.");
      }
    },
    async userMemoUpdate() {
      const reqData = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        password: this.compInfo.memPass,
        memo: this.compInfo.memo
      };
      const res = await partnerModify(reqData);
      if (res.resultCode === "0") {
        alert("메모수정 완료");
      } else {
        alert("메모수정실패, 다시 시도해주세요.");
      }
    },
    parentLinkMove(linkTarget, siteId) {
      console.log("move");
      if (linkTarget === "/reports/totalList") {
        window.opener.location.href = `${linkTarget}?id=${siteId}`;
      } else {
        window.opener.location.href = `/user${linkTarget}?id=${siteId}`;
      }
    },
    async siteOptionSave() {
      const option = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId
      }
      const siteOption = JSON.parse(JSON.stringify(this.siteOption))
      delete siteOption['adminOtp']
      for (const key in siteOption) {
        if (typeof siteOption[key] === "boolean") {
          if (siteOption[key]) {
            siteOption[key] = "Y";
          } else {
            siteOption[key] = "N";
          }
        }
      }
      option['siteOption'] = siteOption
      const res = await companyOptionSave(option);
      if (res.resultCode === "0") {
        await this.getCompanyDetail();
        alert("설정 저장 완료");
      } else {
        alert("설정 저장 실패, 다시 시도해주세요.");
      }
    },
    async getCompanyTree() {
      const reqData = {
        siteId: this.reqData.memId,
        targetId: this.reqData.memId,
        searchType: "partner"
      };
      const res = await companyTree(reqData);
      const list = res.data.list;
      if (list) {
        this.compInfo.subCompanyCnt = list.length;
      } else {
        this.compInfo.subCompanyCnt = 0;
      }
      this.subCompanyList = list;
    },
    switchToggle(event) {
      const toggle = event.target;
      const text = toggle.previousElementSibling;
      // console.log(toggle.checked)
      if (text) {
        if (toggle.checked) {
          text.classList.remove("off");
          text.classList.add("on");
        } else {
          text.classList.remove("on");
          text.classList.add("off");
        }
      }
    },
    async switchToggleOtp(event) {
      const toggle = event.target;
      const text = toggle.previousElementSibling;
      // console.log(toggle.checked)
      let useYn = ''
      if (text) {
        if (toggle.checked) {
          text.classList.remove("off");
          text.classList.add("on");
          useYn = 'Y'
        } else {
          text.classList.remove("on");
          text.classList.add("off");
          useYn = 'N'
        }
      }

      await apiUpdateOtpUseYn({
        useYn,
        account: this.compInfo.siteId
      }).then(result => {
        if (result.resultCode === '0') {
          alert('변경이 완료되었습니다.')
        }
      })

    },
    switchGame (item) {
      item.isBet = !item.isBet
      item.compBetYn = item.isBet ? 'Y': 'N'
    },
    switchSuperGame (item) {
      item.isSuperUse = !item.isSuperUse
      item.superUseYn = item.isSuperUse ? 'Y': 'N'
    },
    switchMenu (item) {
      item.isUse = !item.isUse
      item.useYn = item.isUse ? 'Y': 'N'
    },
    inCashModalClose() {
      this.cashInModal.active = !this.cashInModal.active;
    },
    outCashModalClose() {
      this.cashOutModal.active = !this.cashOutModal.active;
    },
    venderRateModalOpen() {
      this.loadData()
      this.venderRate.active = true;
      document.body.style.overflow = 'hidden';
    },
    venderRateModalClose() {
      this.venderRate.active = false;
      document.body.style.overflow = 'auto';
    },
    modalControl(siteId) {
      this.getCompanyDetail(siteId);
      this.modal.target = siteId;
      this.modal.active = !this.modal.active;
    },
    async getCompanyDetail() {
      // console.log(this.reqData);
      const model = {
        memId: this.reqData.memId,
        siteId: this.reqData.memId
      };
      const res = await companyDetail(model);
      if (res.resultCode !== "0") {
        return;
      }
      this.totalData = JSON.parse(JSON.stringify(res.data))
      const compInfo = res.data.compInfo
      const compStats = res.data.compStats

      if (compInfo) {
        this.compInfo = compInfo
      }
      this.topCompList = res.data.topCompList
      this.botCompList = res.data.botCompList
      this.gameList = res.data.gameList
      this.menuList = res.data.menuList

      this.vendorCompList = res.data.vendorCompList

      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.isBet = item.compBetYn === 'Y' ? true : false
        item.isSuperUse = item.superUseYn === 'Y' ? true : false
      }

      const tempMenu = {}
      for (let i = 0; i < this.menuList.length; i++) {
        const item = this.menuList[i]

        if (!tempMenu[item.menuGroupCode]) {
          item.first = true
        }
        tempMenu[item.menuGroupCode] = '1'
        item.isUse = item.useYn === 'Y' ? true : false
      }

      this.memberFlow = res.data.memberFlow;
      // this.partnerFlow = this.jsonSort(res.data.partnerFlow, "topOrder", "desc");
      // console.log(this.partnerFlow)
      if (this.compInfo.lastLoginDt) {
        this.compInfo.lastLoginDt = this.replceDateT(this.compInfo.lastLoginDt);
      }
      this.compStats = {...compStats}
      for (const item in this.userData) {
        if (item.indexOf("Yn") !== -1 && item !== "memberCommissionRate") {
          if (this.userData[item] === "Y") {
            this.userData[item] = true;
          } else {
            this.userData[item] = false;
          }
        }
      }
      this.memPassChk = compInfo.memPass;

      const setting = res.data.settingInfo
      for (let key in setting) {
        if (setting[key] === 'Y') {
          this.siteOption[key] = true
        } else if(setting[key] === 'N') {
          this.siteOption[key] = false
        } else {
          this.siteOption[key] = setting[key]
        }
      }
    },
    getUserRate() {
      return memberRate(this.reqData);
    },
    getGameCode() {
      return getGameCodes("kplay");
    },
    setRateLoop(maxRate) {
      return maxRate / 0.05;
    },
    getMemLevel() {
      this.userData;
    },
    async setMemStatus() {
      const reqData = {
        siteId: this.compInfo.siteId,
        memStatus: this.compInfo.memStatus
      };
      try {
        const res = await memStatusChange(reqData);
        if (res.resultCode !== "0") {
          alert("회원상태 변경에 실패했습니다. 다시 시도해주세요.");
        } else {
          alert("회원상태 변경완료");
        }
      } catch (e) {
        console.log(e);
        alert("회원상태 변경에 실패했습니다. 다시 시도해주세요.");
      }
    },
    setRateList() {
      this.setRateListDefault();
      this.combineUserRate();
    },
    setRateListDefault() {
      // console.log(this.gameListDefault);
      for (const loop of this.gameListDefault) {
        for (const item of loop.child) {
          const model = lodash.cloneDeep(this.rateModel);
          model.gameType = item.code;
          model.gameName = item.codeName;
          model.groupCode = item.groupCode;
          model.loop = Number(model.maxPointRate) / this.rateIncrease;
          this.rateList.push(model);
        }
      }
      this.originRate = lodash.cloneDeep(this.rateList);
    },
    combineUserRate() {
      const rateList = lodash.cloneDeep(this.rateList);
      for (const loop of this.compInfo.memberCommissionRate) {
        rateList.forEach((target, index, arr) => {
          if (target.gameType === loop.gameType) {
            target.gameType.pointRate = loop.pointRate;
            target.gameType.maxPointRate = loop.maxPointRate;
            target.gameType.loop = Number(loop.maxPointRate) / this.rateIncrease;
            arr.splice(index, 1);
            return false;
          }
        });
      }
      this.originRate = rateList;
      this.rateList = rateList;
    },
    async afterSaveAndGetData () {
      const confirmMessage = '상위 벤더 회사(트리플A)에서 요율을 가져와서 저장합니다. 기존에 저장되어있는 데이더를 덮어쓰게 됩니다. 진행하시겠습니까?'
      if (confirm(confirmMessage)) {
        await setVendorRating({ siteId: this.targetSiteId }).then(async res => {
          if (res.resultCode === '0') {
            const result = res.data.list
            await this.dataProcessing(result)
            alert('저장이 완료되었습니다.')
          }
        })
      } else {
        return false
      }
    },
    async loadData () {
      await getVendorRating({ siteId: this.targetSiteId }).then(async res => {
        if (res.resultCode === '0') {
          const result = res.data.list
          await this.dataProcessing(result)
        }
      })
    },
    async dataProcessing (data) {
      const casinoList = data.filter(item => item.category === 'casino')
      const slotList = data.filter(item => item.category === 'slot')

      const casino = this.productGrouping(casinoList)
      const slot = this.productGrouping(slotList)

      this.list = {
        casino,
        slot
      }
    },
    productGrouping (list) {
      const grouping = {}
      list.forEach(item => {
        const productCode = item.productCode
        this.topMemId = item.topCompId

        if (!grouping[productCode]) {
          grouping[productCode] = {
            productCode,
            productName: item.productName,
            children: []
          }
        }
        grouping[productCode].children.push(item)
      })
      return grouping
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ]),
    getTargetList () {
      return this.list[this.currentTab]
    }
  },
  async created() {
    await this.setGameList();
    this.setRateListDefault();
    await this.getCompanyDetail();
    await this.getCompanyTree();
    // await this.getCompanyOption();
  }
};
</script>

<style scoped>
.w100w {width: 100% !important;}
.w25w {width: 25% !important;}
.bl {color: #0d73ff;}
.ft10 {font-size: 10px !important;}
.fx {display: flex !important;justify-content: initial;}
.fx > table {width: 49% !important;}

.user-wrapper-outer > .middle-wrap .content > .title:first-child {width: 120px;}
.user-wrapper-outer > .middle-wrap.menu {display: flex;justify-content: space-between;flex-wrap: wrap;}
.user-wrapper-outer > .middle-wrap.menu > table {float: none;margin-left: 15px;}
.user-wrapper-outer > .middle-wrap.menu > table.first {margin-left: 5px;}
.user-wrapper-outer > .middle-wrap.menu > table .content.first > .title {color: #0d73ff;}
.cateWrap {display: flex;align-items: center;margin: 0 20px 10px;width: 100%;}
.cateWrap > span {width: 100px;color: #18698b;font-weight: bold;}
.cate {display: flex;gap: 20px;}
.cate .toggle-wrap {gap: 10px;}
.active .btn-t-inner {
  display: none;
}
.fstColumn.userList .levelColor {
  display: block;
}

.box-hideOpen .levelColor {
  background: rgb(255, 218, 38);
  width: 8px;
}
.seletAndDelete {
  display: flex;
  align-items: center;
}
.msg-all-sel {
  margin-right: 4px !important;
  height: 30px;
  box-sizing: border-box;
}
#siteId {
  margin-right: 4px;
}
z .btn-state-change.cancle {
  margin-right: 4px;
}
.user-detail-popup {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 1435px;
  gap: 15px;
  margin: 0;
  box-sizing: border-box;
}
.user-detail-popup select {
  font-size: 1em;
}
.wrapper-title .btn-other {
  height: 21px;
  padding: 0 10px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  background-color: #126ae2;
}
.wrapper-title .btn-save {
  width: 42px;
  height: 21px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  background-color: #126ae2;
}
.wrapper-title .btn-save:hover {
  color: #126ae2;
  background: #fff;
}
.button-wrap {
  display: flex;
}
.button-wrap > button {
  flex: 1;
  margin-right: 4px;
}
.button-wrap > button:last-child {
  margin-right: 0;
}
input[type="text"],
input[type="number"],
input[type="password"] {
  font-weight: 500;
  border: 1px solid #c5c5c5;
  height: 21px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 3px;
}
select {
  border: 1px solid #c5c5c5;
}
.userInfo-select {
  font-weight: 500;
  padding: 2px 5px;
  height: 21px;
  width: 100%;
}
.s-content > .content {
  display: flex;
  height: calc(56px - 26px);
}
.modal-item {
  width: 38%;
  margin: 0 auto;
  position: relative;
  top: 20%;
  background: #fff;
  padding: 10px;
}

.modalWrap .inputWrap {
  display: flex;
  padding: 20px 0;
  gap: 10px;
  justify-content: center;
}
.modalWrap .amtbox {
  display: block;
  width: 50%;
  height: 30px;
}
.modalWrap .btn-blue {
  padding: 5px 10px;
  height: 30px;
  font-size: 13px;
  background: #126ae2;
  color: #fff;
  box-sizing: border-box;
}
.sub-title > h3 {
  width: fit-content;
}
.table-wrap {
  width: 100%;
  overflow-y: scroll;
  max-height: 150px;
  margin-top: 20px;
}
.mainTable {
  font-size: 12px !important;
}
.mainTable th {
  height: 35px;
  /* background: var(--main); */
  background: #18698b;
  color: #fff;
  font-weight: 700;
  vertical-align: middle;
}

.supComp-list-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
span[class^="compColor"] {
  font-weight: bold;
}
span[class^="compColor"]:after {
  content: "▶";
  display: inline;
  margin-left: 5px;
}
span[class^="compColor"]:last-child:after {
  content: "";
}
.compColor-target {
  color: #d82beb;
}
.tab-container {
  width: 100%;
}
.tab-container .tab-wrap {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}
.tab-wrap > input {
  display: none;
}
.tab-wrap > input + label {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  color: #8f8faa;
  border: 1px solid #8f8faa;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;
}
.tab-wrap > input:checked + label {
  color: #27273f;
  background: #fff;
  font-weight: 700;
}
.tab-container .btn-group {
  display: flex;
  width: 100%;
  gap: 5px;
}
.tab-container .btn-group button {
  flex: 1 1 16.5%;
  height: 35px;
  background-color: #126ae2;
  border: 0;
  font-size: 13px;
  color: #ffffff;
  font-weight: 500;
  border-radius: 0px;
}
.user-wrapper-outer > .middle-wrap .content > td {
  padding: 0;
}
.user-wrapper-outer .table-div-line {
  margin: 0 10px;
}
.wrapper-title {
  margin-bottom: 0;
}
.user-detail-popup .wrapper {
  gap: 15px;
}
.s-content-container {
  height: fit-content;
}
.s-content-wrap {
  overflow: visible;
  height: fit-content;
  max-height: unset;
  padding: 15px 0;
}
.s-content {
  display: flex;
  height: fit-content;
  border: 0;
  max-width: unset;
  flex-basis: unset;
  margin: 0;
  width: 23.1%;
  padding: 5px 0;
  box-sizing: border-box;
  justify-content: space-between;
}
.s-content .title {
  overflow: unset;
  display: flex;
  align-items: center;
  text-overflow: unset;
  background: #fff;
  font-size: 10px;
  color: #40405b;
  font-weight: 500;
  width: 110px;
  text-align: left;
  word-break: normal;
  white-space: pre-wrap;
  padding: 0;
}
.s-content-line {
  width: 1px;
  height: 40px;
  margin: 0 8px;
  background: #8f8faa;
}
.btn-reset {
  width: 19px;
  height: 19px;
  border-radius: 3px;
  background-color: #ffffff;
  border: 1px solid #e6e6f6;
  cursor: pointer;
}
.btn-settings {
  min-width: 53px;
  box-sizing: border-box;
  font-size: 10px;
  color: #126ae2;
  font-weight: 500;
  height: 21px;
  border-radius: 5px;
  background-color: #ffffff;
  border: 1px solid #126ae2;
  padding: 0 10px;
  cursor: pointer;
}
.btn-settings:hover {
  background-color: #126ae2;
  color: #fff;
}
.s-content input[type="text"] {
  width: 48px;
  height: 22px;
  background-color: #ffffff;
  border: 1px solid #e6e6f6;
  padding: 0;
  font-size: 10px;
  text-align: center;
}
.rateControl-all {
  width: 65px;
  height: 22px;
  background-color: #ffffff;
  border: 1px solid #e6e6f6;
  padding: 0;
  font-size: 10px;
  text-align: center;
}
.user-wrapper-outer > .middle-wrap{
  border-bottom:0;
  display: block;
}
.user-wrapper-outer > .middle-wrap > table {width: 20%;float: left;margin-bottom: 10px;}
.box-height-fit{
  height:fit-content !important;
  flex:0 !important;
}
.user-wrapper-outer > .middle-wrap.set {display: flex;}
.toggle-wrap {width: auto;}
.otpToggle {display: flex;align-items: center;gap: 15px;}
.otpToggle .use {display: flex;align-items: center;gap: 5px;}
.otpToggle .btn-group {display: flex;align-items: center;gap: 15px;}
.otpToggle .btn-group button {width: 110px;height: 35px;background-color: #fff;border: 1px solid #126ae2;border-radius: 5px;box-sizing: border-box;color: #126ae2;font-size: 13px;font-weight: 500;cursor: pointer;}
.otpToggle .btn-group button:hover {background-color: #126ae2;color: #fff;}

.otpQr {position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);border: 1px solid #8f8faa;border-radius: 2px;background: #fff;width: 300px;padding: 0 13px;z-index: 1;text-align: center;}
.otpQr h4 {height: 42px;border-bottom: 1px solid #c5c5c5;display: flex;justify-content: space-between;align-items: center;font-size: 13px;color: #27273f;font-weight: 700;}
.otpQr h4 a {width: 42px;height: 21px;border-radius: 5px;font-size: 10px;font-weight: 500;background-color: #126ae2;color: #fff;display: flex;justify-content: center;align-items: center;cursor: pointer;}
.otpQr > img {width: 250px;margin: 15px 0;}

.useBottom {margin-top: 15px;padding: 0px 13px;border: 1px solid #8f8faa;border-radius: 2px;}
#venderModal {width: 80%; top: 5%; height: 700px; overflow-y: scroll; }
#venderModal .modal-close{
  font-size: 30px;
  top: -20px;
}
#venderModal .btn-blue {
  background: #126ae2;
  color: #fff;
}
#uiWrap {
  position: relative;
}
#venderModal .sub-title{
  font-weight: bold;
}
#venderModal .rightbtn {
  position: absolute;
  right: 0;
  top: 20px;
  padding: 5px 10px;
}
/* popupTable */
.popupTable {
  width: 100%;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  overflow: hidden;
}
.popupTable thead > tr {
  border: 1px solid #333;
}
.popupTable thead th {
  height: 40px;
  background: #353535;
  color: #fff;
  vertical-align: middle;
  font-size: 14px;
  box-sizing: border-box;
}
.popupTable .tablebodyWrap > tr {
  border: 1px solid #333;
}
.popupTable .tablebodyWrap > tr > td {
  border-right: 1px solid #333;
  padding: 8px 0;
}
.createTable { width: 100%; }
.createTable tr {
  border-bottom: 1px solid #333;
}
.tablebodyWrap .select {
  color: #e76262;
  font-weight: bold;
}
.createTable tr:last-child {
  border-bottom: 0;
}
.createTable tr > td {
  padding: 5px 20px;
  height: 26px;
}
.createTable input[type="number"] {
  width: 50px;
  border-radius: 5px;
  border: 1px solid #b9b9b9;
  padding: 0 10px;
  box-sizing: border-box;
}
/* popupTable tab content */
#tabList {
  padding: 10px 20px 0;
  display: flex;
  gap: 5px;
}
#tabList li{
  padding: 5px 15px;
  font-size: 14px;
  cursor: pointer;
}
#tabList li.on {
  border-bottom: 3px solid #e76262;
  font-weight: bold;
}
</style>
